/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useWizard, Wizard} from "react-use-wizard";
import ArgosFlexbox from "../../Containers/ArgosFlexbox";
import ArgosButton, {ArgosLoadingButton} from "../../Buttons/ArgosButton";
import BoxWithCenteredContent from "../../Containers/BoxWithCenteredContent";
import React, {useState} from "react";
import ArgosTextField from '../../Form/TextField/ArgosTextField';
import {IArgosDialogProps} from "../../Dialogs/ArgosDialog";

import {validateURL} from "../../../../helpers/url/urlHelpers";

interface IAddTreeNodeDialogProps {
  propertyType?: any
  data?: any
  fromApp?: ERequirementsToolTreeDialogAppNames
  onFinish?: any
  onClose?: () => void
  adasProgramId: string
  selectTreeItemsContainerStyle?: React.CSSProperties
  isSingleSelect?: boolean
  isAdd?:boolean
  onSave?: any
}
export enum ESyncReportAction {
  SYNC = 'sync',
  DELETE = 'delete',
  ADD_FOLDER = 'addFolder'
}
const actionsForRefresh = {
  current: new Set([ESyncReportAction.SYNC, ESyncReportAction.ADD_FOLDER]),
  parent: new Set([ESyncReportAction.DELETE])
}
const minMaxWidth = '60vw'
export const SYNC_REPORT_DIALOG_STYLE: Partial<IArgosDialogProps> = {
  minWidth: minMaxWidth,
  maxWidth: minMaxWidth,
  height: '80vh',
  headerTitle: `Sync Report`,
}
const AddTreeNodeDialog = (props: IAddTreeNodeDialogProps) => {
  const [itemName, setItemName] = useState(props.data?.rowData.name)
  const [itemURL, setItemURL] = useState(props.data?.rowData.property_link)

  return (
    <div style={{height: '100%'}}>
      <Wizard>
        <DNGForm
          setItemName={setItemName}
          isAdd={props?.isAdd}
          itemName={itemName}
          setItemURL={setItemURL}
          itemURL={itemURL}
          shouldShowFooter={true}
          onFinish={() => {
            if (props?.onFinish) {
              props.onFinish()
            }
          }}
          fromWizard={true}
          fromApp={props.fromApp}
          data={props.data}
          propertyType={props.propertyType}
          onSave={props.onSave}
          onClose={props.onClose}
        />
      </Wizard>
    </div>
  )
}
const DNGForm = (props: any) => {
  const [error, setError] = useState(false)
  const {shouldShowFooter, fromApp} = props
  const handleFinish = async () => {
    if (fromApp == ERequirementsToolTreeDialogAppNames.COVERAGE_REQUIREMENTS) {
      if (props?.onFinish) {
        // Save new property object
        let newObj: any = {}
        newObj['type'] = props.propertyType
        newObj['category'] = props.data.category
        newObj['name'] = props?.itemName
        newObj['property_link'] = props?.itemURL
        props.onSave(newObj, props?.isAdd, props?.data.index)
        props.onFinish()
      }
    }
  }


  return (
    <ArgosFlexbox vertical style={{height: '100%'}}>
      <BoxWithCenteredContent horizontal vertical flexFlow={'column nowrap'}>
        <div>Select DNG Item</div>
        <ArgosTextField
          //required
          onChange={(e: any) => props?.setItemName(e.target.value)}
          value={props?.itemName}
          //name="name"
          //sx={{width: fieldWidth, height: fieldHeight}}
          type="text"
          id="outlined-basic"
          label="Item Name"
        />
        <ArgosTextField
          onBlur={(e: any) => setError(!validateURL(e.target.value))}
          error={error}
          helperText={error && `Invalid URL`}
          //required
          onChange={(e: any) => props?.setItemURL(e.target.value.trim())}
          value={props?.itemURL}
          //name="study_description"
          //sx={{width: fieldWidth, height: 2 * fieldHeight}}
          type="text"
          id="outlined-basic"
          label="Item URL"
        />
      </BoxWithCenteredContent>
      {!error && (shouldShowFooter && props.fromWizard ?
        <Footer
          onFinish={() => {
            handleFinish()
          }}
          onClose={props.onClose}
          isLastStep={true}
        />
        :
        <ArgosFlexbox style={{marginTop: 'auto', justifyContent: 'center'}}>
          <ArgosButton
            onClick={() => {
              props?.onFinish && props.onFinish()
            }}
          >
            Cancel
          </ArgosButton>
          <ArgosButton
            onClick={() => {
              handleFinish()
            }}
          >
            Finish
          </ArgosButton>
        </ArgosFlexbox>)
      }
    </ArgosFlexbox>
  )
}

export enum ERequirementsToolTreeDialogAppNames {
  COVERAGE_REQUIREMENTS = 'CoverageReqts',
  ADAS_PROGRAMS = 'AdasPrograms',
  VEHICLE_PROGRAMS = 'VehiclePrograms'
}

const FINISH_BUTTON_TEXT_MAP: any = {
  [ERequirementsToolTreeDialogAppNames.COVERAGE_REQUIREMENTS]: 'Finish',
  [ERequirementsToolTreeDialogAppNames.ADAS_PROGRAMS]: 'Add report to this location',
}

interface IFooterProps {
  isFirstStep?: boolean
  isLastStep?: boolean
  onFinish?: () => void
  onClose?: () => void
  finishButtonText?: string
  isFinishButtonDisabled?: boolean
  isFinishLoading?: boolean
}

export const Footer = (props: IFooterProps) => {
  const {nextStep} = useWizard();

  return (
    <ArgosFlexbox style={{marginTop: 'auto', justifyContent: 'center'}}>
      <ArgosButton style={{visibility: props.onClose ? 'visible' : 'hidden'}}
                   onClick={() => props.onClose && props.onClose()}>
        Cancel
      </ArgosButton>
      {!props.isLastStep ?
      <ArgosButton style={{visibility: !props.isLastStep ? 'visible' : 'hidden'}} onClick={() => nextStep()}>
        Next
      </ArgosButton>
      :
      <ArgosLoadingButton
        style={{visibility: props.isLastStep ? 'visible' : 'hidden'}}
        disabled={props?.isFinishButtonDisabled ?? false}
        isLoading={props?.isFinishLoading ?? false}
        onClick={() => {
          if (props?.onFinish) {
            props.onFinish()
          }
        }}
      >
        {props?.finishButtonText ?? 'Finish'}
      </ArgosLoadingButton>
      }
    </ArgosFlexbox>
  )
}

export default AddTreeNodeDialog;